// pages/FormViewerPage/components/HerbalShippingClaimCard.tsx — Mode Herbal: Pilihan Lanjut WA vs Klaim Potongan Ongkir (Ramping & Ramah Orang Tua)
// Opsi di ClaimModeOptions.tsx; kotak alamat di ClaimAddressBox.tsx (split SOP ≤100 baris).
import React from 'react';
import type { Form } from '../../../types';
import type { AddressData } from '../../../components/AddressInput';
import { getLargestSubsidy, getShippingPolicy } from '../../../utils/shippingSubsidy';
import { ClaimModeOptions } from './ClaimModeOptions';
import { ClaimAddressBox } from './ClaimAddressBox';

interface HerbalShippingClaimCardProps {
    form: Form;
    claimMode: 'wa' | 'claim_ongkir';
    onClaimModeChange: (mode: 'wa' | 'claim_ongkir') => void;
    addressData: AddressData;
    onAddressChange: (data: AddressData | ((prev: AddressData) => AddressData)) => void;
    fieldErrors?: Record<string, string>;
}

export const HerbalShippingClaimCard: React.FC<HerbalShippingClaimCardProps> = ({
    form,
    claimMode,
    onClaimModeChange,
    addressData,
    onAddressChange,
    fieldErrors,
}) => {
    const policy = getShippingPolicy(form);
    const maxSubsidy = getLargestSubsidy(form);

    // Keterangan potongan ongkir yang ringkas & jelas untuk orang tua
    let promoTitleShort = 'Diskon Ongkir';
    let promoDescShort = 'Isi alamat di bawah, ongkir dipotong';

    if (policy === 'gratis') {
        promoTitleShort = 'Gratis Ongkir';
        promoDescShort = 'Isi alamat di bawah, ongkir Rp 0';
    } else if (policy === 'subsidi' && maxSubsidy > 0) {
        promoTitleShort = `Diskon Ongkir Rp ${maxSubsidy.toLocaleString('id-ID')}`;
        promoDescShort = 'Isi alamat di bawah, ongkir dipotong';
    }

    const currentDetailAddress = addressData.detailAddress || addressData.fullAddress || '';

    return (
        <div className="space-y-2 pt-1">
            <div className="flex items-center justify-between">
                <span className="text-xs font-semibold text-slate-700 dark:text-slate-300">
                    Pilihan Pemesanan:
                </span>
                <span className="text-[10px] text-slate-500 dark:text-slate-400">
                    Pilih salah satu di bawah
                </span>
            </div>

            {/* 2 Pilihan Ramping Berdampingan (Hemat Ruang & Sangat Jelas) */}
            <ClaimModeOptions
                claimMode={claimMode}
                onClaimModeChange={onClaimModeChange}
                promoTitleShort={promoTitleShort}
                promoDescShort={promoDescShort}
            />

            {/* Kotak Pengisian Alamat — Terbuka saat memilih Klaim Ongkir */}
            {claimMode === 'claim_ongkir' && (
                <ClaimAddressBox
                    promoTitleShort={promoTitleShort}
                    currentDetailAddress={currentDetailAddress}
                    onAddressChange={onAddressChange}
                    fieldErrors={fieldErrors}
                />
            )}
        </div>
    );
};
